"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
function setCanStartStream(state) {
  return (0, _actionUtils.actionCreator)(_types.BROADCAST_SET_CAN_START_STREAM, state);
}
var _default = exports["default"] = setCanStartStream;